import { icons } from '@shared/static/icons';
import {
  currencySymbols,
  binsLogo,
  MASTER_BANK_ID,
  REFERRAL_BANK_ID,
} from '@utils/static';
import { CountryFlag } from '@shared/ui/parts';
import { formatBalanceUi } from '@utils/balance-helpers';

export default function RenderItemBank({
  item,
  displayBalance = false,
  arrowIcon = false,
}) {
  return (
    <div className="select-bank-item">
      {item?.bank_id === MASTER_BANK_ID ||
      item?.bank_id === REFERRAL_BANK_ID ? (
        icons[item?.bank_name]
      ) : (
        <CountryFlag countryCode={binsLogo[item?.bank_id]} />
      )}

      <div>
        <p>{item?.bank_public_name}</p>
        <p className="secondary-text">
          {displayBalance
            ? formatBalanceUi(item?.balance, item?.currency)
            : item?.bin}
        </p>
      </div>
      <div className="select-bank-payment">
        {item?.card_type !== 'unknown' && icons[item?.card_type]}
        <p className="select-bank-symbol">{currencySymbols[item?.currency]}</p>
        {arrowIcon && icons['chevron-right']}
      </div>
    </div>
  );
}
